module.exports = __webpack_public_path__ + "img/OZENCHAWENGNOIPROJECT.32401098.png";